<template>
  <div class="sy-unit">
    <filterSelect
      v-on="$listeners"
      v-bind="$attrs"
      :api="Api.enableUnitList"
      :keys="unitNewKeys"
      :getParams="(query) => ({ searchKeyword: query, pageSize: 50 })"
    ></filterSelect>
  </div>
</template>
<script>
import filterSelect from '../../basis/filter-select/index'
import Api from './api.js'
import response from '../../../utils/response'
import { componentMessage } from '../utils'
export default {
  components: {
    filterSelect
  },
  props: {
    keys: {
      type: String,
      default: () => ({})
    },
    code: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      Api,
      unitKeys: {
        optionsValueKey: 'id',
        optionsLabelKey: '_optionsLabel',
        labelCombined: ['unitName', 'unitCode'], // model 中的字段的 key
        optionsLabelCombined: ['name', 'code'], // 下拉option 中的字段的 key, 和上一个一一对应
        labelSeparator: ' / ' // 分隔符
      }
    }
  },
  computed: {
    unitNewKeys () {
      return { ...this.unitKeys, ...this.keys }
    }
  },
  watch: {
    code: {
      handler (val)  {
        if (val) {
          this.checkCode(val)
        }
      },
      immediate: true
    }
  },
  methods: {
    // 校验禁用
    async checkCode () {
      let api = Api.validate
      let res = await response(this.$http(api.type, `${api.url}/${this.code}`))
      if (res.isOk) {
        this.$emit('validCode', res.content)
      }
    }
  },
  created() {
    // 适用于商城端和采购商端
    let flag = componentMessage(['mall', 'purchaser', 'suplier'], 'unit 单位')
    if (flag) return
  }
}
</script>
<style lang="scss" scoped>

</style>